<!-- Loading state -->
@if (isLoading()) {
<div class="flex justify-center p-4">
  <div
    class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"
  ></div>
</div>
}

<!-- No cards state -->
@if (!isLoading() && (!cards )) {
<div class="text-center p-4">No tienes tarjetas guardadas</div>
}

<!-- Cards list -->

@if(!isLoading() && !hasError && cards && cards.length > 0) {
<div>
  @for (card of cards; track card) {
  <div
    [ngClass]="{
      'border-yellow-600 bg-yellow-50 shadow-md':
        selectedPaymentCard?.stripe_payment_method_id ===
        card.stripe_payment_method_id,
      'border-gray-300 bg-white':
        selectedPaymentCard?.stripe_payment_method_id !==
        card.stripe_payment_method_id
    }"
    class="border rounded-lg p-4 mb-3 flex items-center justify-between shadow-sm hover:shadow-md transition-all duration-200 relative"
  >
    @if (selectedPaymentCard?.stripe_payment_method_id ===
    card.stripe_payment_method_id) {
    <div
      class="absolute -left-2 top-1/2 transform -translate-y-1/2 bg-yellow-600 text-white rounded-full p-1"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    }
    <div class="flex items-center">
      <div class="mr-3 bg-gray-200 p-2 rounded-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-gray-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          />
        </svg>
      </div>
      <div>
        <div class="font-medium">{{ card.brand_name }}</div>
        <div class="text-gray-600 text-sm">**** {{ card.last4 }}</div>
      </div>
    </div>
    <div class="flex items-center gap-3">
      @if(showButton){
      <button
        (click)="selectCard(card)"
        [ngClass]="{
          'bg-yellow-600 hover:bg-yellow-700':
            selectedPaymentCard?.stripe_payment_method_id ===
            card.stripe_payment_method_id,
          'bg-gray-500 hover:bg-gray-600':
            selectedPaymentCard?.stripe_payment_method_id !==
            card.stripe_payment_method_id
        }"
        class="cursor-pointer text-white p-2 rounded-full transition-all duration-200 flex items-center justify-center"
        aria-label="Seleccionar tarjeta"
        title="Seleccionar tarjeta"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </button>
      } @if(cards.length > 1){
      <button
        (click)="openDeleteModal(card)"
        class="cursor-pointer bg-red-500 hover:bg-red-600 text-white p-2 rounded-full transition-all duration-200 flex items-center justify-center"
        aria-label="Eliminar tarjeta"
        title="Eliminar tarjeta"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
      </button>
      }
    </div>
  </div>
  }
</div>

}

<!-- Add new card button - Mostrar siempre cuando showCards() es true O cuando no hay tarjetas -->
@if(!isLoading()) {
<div class="mt-4">
  <button
    (click)="openAddCardModal()"
    class="w-full bg-yellow-500 text-white py-2 px-4 rounded-lg hover:bg-yellow-600 transition-colors flex items-center justify-center gap-2 mb-5"
    [disabled]="isLoadingAddCard"
  >
    @if (isLoadingAddCard ) {
    <div class="mr-2">
      <svg
        class="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
    } @if (!isLoadingAddCard) {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 4v16m8-8H4"
      />
    </svg>
    } Agregar nueva tarjeta
  </button>
</div>
}

<!-- Add new card modal -->
<stripe-add-new-card
  (cardAdded)="loadUserCards()"
  (modalOpened)="isLoadingAddCard = false"
></stripe-add-new-card>

<!-- Delete card modal -->
@if (showDeleteModal) {
<mercado-pago-delete-card-modal
  [card]="selectedCard"
  (closeModal)="closeDeleteModal()"
  (cardDeleted)="onCardDeleted()"
></mercado-pago-delete-card-modal>
}
